import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../features/auth/auth.service';

@Injectable({
  providedIn: 'root'
})

export class SessionService {

  actions: any;

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  singIn(session: any) {
    localStorage.setItem('isAuth', 'true');
    localStorage.setItem('profile', JSON.stringify(session.profile));
    localStorage.setItem('views', JSON.stringify(session.views));
    localStorage.setItem('actions', JSON.stringify(session.actions));
    localStorage.setItem('user', JSON.stringify(session.user));
    localStorage.setItem('permissions', JSON.stringify(session.permissions));
    localStorage.setItem('token', session.token);
  }

  logOut() {
    if(this.isAuth()) {
      this.authService.logout().subscribe();
      this.removeData();
      this.router.navigate(['/login']);
    }
  }

  removeData() {
    localStorage.removeItem('isAuth');
    localStorage.removeItem('profile');
    localStorage.removeItem('views');
    localStorage.removeItem('actions');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
    localStorage.removeItem('token');
  }

  getToken(): string {
    return localStorage.getItem('token') || '';
  }

  getUserViews(): any {
    const views = JSON.parse(localStorage.getItem('views') || '[]');
    return views;
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }

  getUserPermissions(): any {
    if (localStorage.getItem('permissions') && localStorage.getItem('permissions') !== 'undefined') {
      return JSON.parse(localStorage.getItem('permissions') || '{}');
    } else {
      return {};
    }
  }

  getUserProfile(): any {
    return JSON.parse(localStorage.getItem('profile') || '{}');
  }

  hasPermissionAction(permission: string): boolean {
    if(!this.actions?.length) {
      this.actions = JSON.parse(localStorage.getItem('actions') || '[]');
    }
    
    return this.actions.includes(permission);
  }

  isAuth() {
    return localStorage.getItem('isAuth') && localStorage.getItem('token');
  }
}

export const provideSessionService = {
  provide: SessionService,
  useClass: SessionService
};
